<template>
  <div>
    <b-card no-body>
      <b-table
        id="subsidies"
        ref="table"
        class="bg-white"
        responsive
        show-empty
        :fields="fields"
        :items="items"
      >
        <template v-slot:empty>
          <p align="center">
            <span v-if="!busy">{{ trans('none') }}</span>
            <span v-if="busy">
              <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
              {{ trans('please_wait') }}
            </span>
          </p>
        </template>
        <template v-slot:cell(name)="data">
          <div>{{ data.value }}</div>
          <small v-if="data.item.recipient && data.item.recipient.email" class="d-block">
            <b-link :href="`mailto:${data.item.recipient.email}`">{{ data.item.recipient.email }}</b-link>
          </small>
        </template>
        <template v-slot:cell(applies_to)="data">
          <small v-if="data.item.any_package" class="d-block">{{ trans('any_package') }}</small>
          <div v-if="!data.item.any_package" v-for="pkg in data.item.packages" :key="pkg.id">
            <a :href="`${iframeUrlPrefix}/org/${organization.id}/package/${pkg.id}`" target="_blank">
              <small>
                {{ pkg.name }}
                <i class="fa fa-fw fa-external-link-alt"></i>
              </small>
            </a>
          </div>
          <small v-if="data.item.any_product" class="d-block">{{ trans('any_product') }}</small>
          <div v-if="!data.item.any_product" v-for="product in data.item.products" :key="product.id">
            <a :href="`${iframeUrlPrefix}/org/${organization.id}/products#product-card-${product.id}`" target="_blank">
              <small>
                {{ product.name }}
                <i class="fa fa-fw fa-external-link-alt"></i>
              </small>
            </a>
          </div>
          <small v-if="data.item.any_class" class="d-block">{{ trans('any_class') }}</small>
          <div v-if="!data.item.any_class" v-for="cls in data.item.am_classes" :key="cls.id">
            <small>
              {{ cls.name }}
            </small>
          </div>
          <small v-if="data.item.any_membership" class="d-block">{{ trans('any_membership') }}</small>
          <div v-if="!data.item.any_membership" v-for="membership in data.item.memberships" :key="cls.id">
            <small>
              {{ membership.name }}
            </small>
          </div>
        </template>
      </b-table>
      <div v-if="notAvailableCount > 0" class="pb-4 pt-0 text-center">
        <b-button variant="link" @click="show_not_available = ! show_not_available">
          {{ trans('not_available') }} ({{ notAvailableCount }})
          <i :class="`fa fa-fw fa-caret-${show_not_available ? 'up' : 'down'}`"></i>
        </b-button>
      </div>
    </b-card>
    <b-alert show variant="primary" class="my-4">
      <p>
        <i class="fa fa-fw fa-info-circle"></i>
        {{ trans('client_subsidy_discounts_about') }}
      </p>
    </b-alert>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
    },
    data() {
      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
        busy: false,
        error: null,
        fields: _.compact([
          {key: 'name', label: trans('description')},
          {
            key: 'amount',
            label: trans('discount'),
            formatter(value, key, item) {
              value = item.type == 'amount' ? value : item.percentage
              if (!value) return null
              return numeral(parseFloat(value)).format(item.type == 'amount' ? '0.00' : '0.[00]%')
            },
          },
          {
            key: 'applies_to',
            label: trans('applies_to'),
          },
          {
            key: 'allow_multiple_use_per_client',
            label: trans('max_usage'),
            formatter(value, key, item) {
              return value ? trans('unlimited') : 1
            },
          },
          {
            key: 'is_available',
            label: trans('available'),
            formatter(value, key, item) {
              return value ? trans('yes') : trans('already_used')
            },
          },
        ]),
        show_not_available: false,
        subsidies: null,
      }
    },
    computed: {
      items() {
        let not_available = []
        let subsidies = _.reduce(this.subsidies || [], (subsidies, subsidy) => {
          if (subsidy.is_available) subsidies.push(subsidy)
          else not_available.push(subsidy)
          return subsidies
        }, [])
        return this.show_not_available ? _.union(subsidies, not_available) : subsidies
      },
      notAvailableCount() {
        return _.reduce(this.subsidies || [], (count, subsidy) => {
          if (!subsidy.is_available) count += 1
          return count
        }, 0)
      },
    },
    methods: {
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/discounts`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.subsidies = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.subsidies = []
        })
      },
    },
    mounted() {
      window.mySubsidies = this
      if (!this.subsidies) this.fetch()
    },
  }
</script>